

class GridLayoutSwitcher extends HTMLElement {

    constructor() {
        super();
        this.buttonClick = this.buttonClick.bind(this);
        this.layoutChange = this.layoutChange.bind(this);
    }

    connectedCallback() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.querySelectorAll('button').forEach(button => {
            button.addEventListener('click', this.buttonClick);
        });

        this.addEventListener('layoutChange', this.layoutChange);
    }

    buttonClick(event) {
        const button = event.target;

        if (button.classList.contains('active') || button.dataset.layout === undefined) {
            return;
        }


        this.querySelectorAll('button').forEach(button => {
            button.classList.remove('active');
        });
        button.classList.add('active');

        this.layoutChange({ layoutString: button.dataset.layout });
    }

    layoutChange({ layoutString }) {
        const producGridLayoutContainer = document.querySelector('[data-grid-layout-container]');

        if (!producGridLayoutContainer) {
            console.error('No grid layout container found');
            return;
        }

        producGridLayoutContainer.dataset.gridLayoutContainer = layoutString;

        this.saveLayout(layoutString);
    }

    saveLayout(layoutString) {
        fetch(`${ window.themeVariables.routes.cartUrl }/update.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: {
                    '_gtc-grid-layout': layoutString
                },
            }),
        });
    }
}

if (!customElements.get('gtc-grid-layout-switcher')) {
    customElements.define('gtc-grid-layout-switcher', GridLayoutSwitcher);
}